import * as api from '../../services/withdrawVerify'

export const FETCH_WITHDRAWVERIFYS= 'FETCH_WITHDRAWVERIFYS';



export const fetchWithdrawverifys = (params, pagination, sort, extra) => {

    return {
        type: FETCH_WITHDRAWVERIFYS,
        payload: {
            promise: api.findWithdrawverifys(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/withdrawVerify.js